'use client'

import { useRef } from 'react'

import { BackTop } from '@/components/ui/back-top'
import { ScrollArea } from '@/components/ui/scroll-area'

interface AppsLayoutProps {
  children: React.ReactNode
}

/**
 * Apps 页面布局组件
 * 包含 ScrollArea、输入框和返回顶部按钮
 */
export function AppsLayout({ children }: AppsLayoutProps) {
  const scrollRef = useRef<HTMLDivElement>(null)

  return (
    <ScrollArea ref={scrollRef} className="h-full">
      {children}

      {/* 返回顶部按钮 */}
      <BackTop className="hidden md:flex" target={scrollRef} />
    </ScrollArea>
  )
}
